(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-testimonials"] && !Shopify.designMode) return;
  try {
    
 $('.testimonial-slider').on('init afterChange', function(event, slick, currentSlide){
  $('.testimonial-slider .slick-slide').removeClass('custom-active');
  var $firstVisible = $('.testimonial-slider .slick-slide.slick-active').first();
  $firstVisible.addClass('custom-active');
});

$('.testimonial-slider').slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 2.3,
  slidesToScroll: 1,
  appendArrows: '.testimonial-slider-arrows',
  prevArrow: `<button type="button" class="slick-prev custom-arrow">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next custom-arrow">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>`,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1.2 }
    }
  ]
});


  } catch(e) { console.error(e); }
})();
})();
